/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createSelector } from 'reselect';


function formatSlot(slot) {
  const s = String(slot);
  if (s.length >= 12) {
    return `${s.slice(6, 8)}/${s.slice(4, 6)} ${s.slice(8, 10)}:${s.slice(10, 12)}`;
  }
  if (s.length >= 10) {
    return `${s.slice(6, 8)}/${s.slice(4, 6)} ${s.slice(8, 10)}:00`;
  } else if (s.length >= 8) {
    return `${s.slice(6, 8)}/${s.slice(4, 6)}`;
  }
  return s.slice(4, 6);
}

const statsSelectors = {
  sf: state => state.gateway.getGatewaySFStats,
  freq: state => state.gateway.getGatewayFreqStats,
  pkt: state => state.gateway.getGatewayPktStats,
};

function toGroupBySeries(list, groupBy, dataField, timeField = 'slot') {
  const categories = _.sortBy(_.uniq(_.map(list, groupBy)), Number);
  const slots = _.uniq(_.map(list, timeField)).sort();

  const series = _.map(categories, (cat) => {
    const l = _.filter(list, item => item[groupBy] === cat);
    const data = _.map(slots, (slot) => {
      const cnt = _.find(l, { slot });
      if (cnt) {
        return cnt[dataField];
      }
      return 0;
    });
    return { name: String(cat), data };
  });
  return {
    series,
    categories: _.map(slots, formatSlot),
    legend: _.map(categories, _.toString),
  };
}

export const toDistrTrendOption = key => createSelector(
  statsSelectors[key],
  (distr) => {
    if (distr.status === 'success') {
      return toGroupBySeries(distr.data.list, key, 'count');
    }
    return {
      categories: [],
      series: [],
      legend: [],
    };
  },
);

export const toPktPieData = createSelector(
  statsSelectors.pkt,
  (pkts) => {
    if (pkts.status !== 'success') {
      return {};
    }
    return pkts.data.list.reduce((res, item) => ({
      pkts: res.pkts + item.rxpkt,
      pktsau: res.pktsau + (item.rxpkt - item.rxpktun),
      pktsun: res.pktsun + item.rxpktun,
    }), {
      pkts: 0,
      pktsau: 0,
      pktsun: 0,
    });
  },
);

export const toDistrPieData = key => createSelector(
  statsSelectors[key],
  (distr) => {
    if (distr.status === 'success') {
      return _.mapValues(_.groupBy(distr.data.list, key), values => _.sumBy(values, 'count'));
    }
    return {};
  },
);


const toTOAStats = state => state.gateway.getGatewayTOAStats;
export const toTOAUplinkTrendSeries = createSelector(
  toTOAStats,
  (toaStats) => {
    if (toaStats.status === 'success') {
      return toGroupBySeries(toaStats.data.list, 'freq', 'uplink');
    }
    return {
      categories: [],
      series: [],
      legend: [],
    };
  },
);
export const toTOAUplinkPieData = createSelector(
  toTOAStats,
  (toaStats) => {
    if (toaStats.status === 'success') {
      return _.mapValues(_.groupBy(toaStats.data.list, 'freq'), values => _.sumBy(values, 'uplink'));
    }
    return {};
  },
);




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/GatewayDetail/coms/selectors.js